
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const DocumentSignature20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91.07.08c-.19.11-.37.25-.53.41L13.94 8H11.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.94l1-1V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5Zm4.3.55-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5-.02.1H6.5a.5.5 0 0 0 0 1H11a.5.5 0 0 0 .23-.06l1.37-.34c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z"
            fill="currentColor"
        />
    </svg>
}